
// animations
const _base = ['animate__animated']
const _flash = [ ..._base, 'animate__flash']
const _tada = [ ..._base, 'animate__tada']
const _rubberBand = [..._base, 'animate__rubberBand']

/**
 * Add css classes to an element
 * @param {HTMLElement} elem the element to apply stuff to
 * @param {String[]} classes array of classes to add
 */
export function _addClassesTo(elem, classes) {
  elem.classList.add(...classes)
}

export function _removeClass(elem, classes) {
  classes.forEach(cl => elem.classList.remove(cl))
}

export const flash = (elem) => _addClassesTo(elem, _flash)
export const tada = (elem) => _addClassesTo(elem, _tada)
export const rubberBand = (elem) => _addClassesTo(elem, _rubberBand)

export function composite(func1, func2) {
  return function (elem) {
    func1(elem)
    func2(elem)
  }
}

export function parentTag(nodeName) {
  return function (elem) {
    while (elem != null && (elem.nodeName||'').toUpperCase() != nodeName.toUpperCase()) {
      elem = elem.parentNode
    }
    return elem
  }
}

export function forEachChild(parentNodeName, childCssSelector, perform) {
  return function (e) {
    let elem = e.target
    const parent = parentTag(parentNodeName)(elem)
    if (parent) {
      Array.from(parent.querySelectorAll(childCssSelector)).forEach(c => perform(c))
    }
  }
}

export function clearAnims (elem) {
  Array.from(elem.classList)
    .filter(c => c.indexOf('animate__') === 0)
    .forEach(cl => elem.classList.remove(cl))
}

export function reactWith(method, findBy) {
  return function (e) {
    // add the method
    let elem = e.target
    // move up hierarchy?
    if (typeof findBy === 'function') {
      elem = findBy(elem)
    }
    // animate
    if (elem) {
      method(elem)
    }
  }
}